import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../Navbar/Navbar.js";
import Realestate from "../../../Images/Real-estate-software-development.svg";
import Footer from "../../Footer/Footer.js";
import DetailsCard from "./DetailsCard.js";
import cardData from "../../../resources/cardData.json";
import logoTextData from "../../../resources/logoTextData.json";
import imageHeader from "../../../resources/imageHeader.json";
import SubHeadings from "./SubHeadings.js";
import ImageHeader from "./ImageHeader.js";
import SliderPage from "./SliderPage.js";
import realEstate from "../../../Images/realEstateImage.jpg";
// import realEstate from "../../../Images/realEstate2.jpg";
import { ReactComponent as Trending } from "feather-icons/dist/icons/trending-up.svg";
import { ReactComponent as Search } from "feather-icons/dist/icons/home.svg";
import { ReactComponent as Collab } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as Settings } from "feather-icons/dist/icons/settings.svg";
import { ReactComponent as Cloud } from "feather-icons/dist/icons/cloud-rain.svg";
import { ReactComponent as Tool } from "feather-icons/dist/icons/phone-call.svg";
import { ReactComponent as File } from "feather-icons/dist/icons/file-plus.svg";
import { ReactComponent as Refresh } from "feather-icons/dist/icons/refresh-ccw.svg";
import { ReactComponent as Houses } from "../../../Images/houses.svg";
import { ReactComponent as Contract } from "../../../Images/journal-check.svg";
import { ReactComponent as Inventory } from "../../../Images/building-gear.svg";
import { ReactComponent as Bank } from "../../../Images/bank.svg";
import { ReactComponent as Currency } from "../../../Images/coin.svg";
import { ReactComponent as Shop } from "../../../Images/shop.svg";
import { ReactComponent as FileText } from "feather-icons/dist/icons/file-text.svg";
import { ReactComponent as Receipt } from "../../../Images/receipt.svg";
import { ReactComponent as Calender } from "feather-icons/dist/icons/calendar.svg";
import { ReactComponent as Claim } from "../../../Images/shield-check.svg";
import { ReactComponent as Cube } from "../../../Images/boxes.svg";
import { ReactComponent as Bulb } from "../../../Images/bulb.svg";

import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs.js";
import ContactUsButton from "./ContactUsButton.js";
import IconCard from "./IconCard.js";
import TechStack1 from "./TechStack1.js";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Database } from "feather-icons/dist/icons/database.svg";
import { ReactComponent as Location } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as Dollar } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Message } from "feather-icons/dist/icons/message-square.svg";
import { ReactComponent as Key } from "feather-icons/dist/icons/key.svg";
import { ReactComponent as DollarIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Award } from "feather-icons/dist/icons/award.svg";

const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row  md:flex-row md:items-stretch md:justify-center sm:flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg`;
const Description = tw.p`px-6 font-semibold py-5 my-10 text-sm md:text-xl text-gray-900 text-center`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const Navtabs = styled.div`
  ${tw`max-w-screen-xl mx-auto m-3 sticky`}
`;
const Navtabslink = tw.p`inline-flex items-center border-b-2 border-transparent hover:cursor-pointer hover:border-primary-700 font-semibold text-black`;
const Navline = styled.div`
  ${tw`text-primary-500`}
`;
// const Navtabslink = styled.span((props) => [
//   tw`inline-flex items-center border-b-2 border-transparent hover:cursor-pointer hover:border-primary-700  hover:text-primary-700 text-black`,
//   props.active ? tw`text-primary-600 font-bold	 border-b-2 ` : tw`text-black`,
// ]);

let data = [
  {
    imageSrc: <Bulb />,
  },
  {
    imageSrc: <DollarIcon />,
  },
  {
    imageSrc: <Award />,
  },
  {
    imageSrc: <Trending />,
  },
  {
    imageSrc: <Settings />,
  },
  {
    imageSrc: <Collab />,
  },
];

const imgStyle = { width: "40px", height: "40px" };

let ExpertiseData = [
  {
    imageSrc: <Search style={imgStyle} />,
  },
  {
    imageSrc: <Cloud style={imgStyle} />,
  },
  {
    imageSrc: <Houses style={imgStyle} />,
  },
  {
    imageSrc: <Trending style={imgStyle} />,
  },
  {
    imageSrc: <Settings style={imgStyle} />,
  },
  {
    imageSrc: <Tool style={imgStyle} />,
  },
  {
    imageSrc: <Currency style={imgStyle} />,
  },
  {
    imageSrc: <Bank style={imgStyle} />,
  },
];

let ServicesData = [
  {
    imageSrc: <Shop style={imgStyle} />,
  },
  {
    imageSrc: <FileText style={imgStyle} />,
  },
  {
    imageSrc: <Receipt style={imgStyle} />,
  },
  {
    imageSrc: <Calender style={imgStyle} />,
  },
  {
    imageSrc: <File style={imgStyle} />,
  },
  {
    imageSrc: <Claim style={imgStyle} />,
  },
  {
    imageSrc: <Cube style={imgStyle} />,
  },
  {
    imageSrc: <Refresh style={imgStyle} />,
  },
  {
    imageSrc: <Contract style={imgStyle} />,
  },
  {
    imageSrc: <Inventory style={imgStyle} />,
  },
];

const keyBenefits = cardData.realEstate.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const ourExpertise = logoTextData.realestate.ourexpertise.map((item, index) => (
  <IconCard
    key={index}
    title={item.title}
    description={item.description}
    imageSrc={ExpertiseData[index].imageSrc}
  />
));

const ourServices = logoTextData.realestate.ourservices.map((item, index) => (
  <IconCard
    key={index}
    title={item.title}
    description={item.description}
    imageSrc={ServicesData[index].imageSrc}
  />
));

const RealEstate = ({ imagehalf, title, title1 }) => {
  const [activeSection, setActiveSection] = useState(null);
  // const [currentNav, setCurrentNav] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const divs = document.querySelectorAll(".div-class");
      let topDiv = null;
      let minTop = Infinity;

      divs.forEach((div) => {
        const { top } = div.getBoundingClientRect();
        if (top >= 0 && top < window.innerHeight && top < minTop) {
          minTop = top;
          topDiv = div.id;
        }
      });

      setActiveSection(topDiv);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const styles = `
  .active {
    font-weight: semibold;
    color: #f56565;
    // color: #6415ff;
    // border-bottom: 1px solid #f56565;
  }
`;

  let [current, setCurrent] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  let previousSlide = () => {
    if (current === 0) setCurrent(slides.length - 1);
    else setCurrent(current - 1);
  };

  let nextSlide = () => {
    if (current === slides.length - 1) setCurrent(0);
    else setCurrent(current + 1);
  };

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 10000); // Change 5000 to adjust interval time (in milliseconds)
    return () => clearInterval(intervalId);
  }, [current]);
  let slidesData = [
    {
      image: realEstate,
      typeID: "element2",
      typedHead:
        "We bring our deep expertise of the U.S. real estate market to your advantage|",
      heading1: "Real Estate  ",
      heading2: "Software Development Company",
      route: "/what-we-do/real-estate-software-company",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  useEffect(() => {
    document.title =
      "Welcome to Iqura - Real Estate Software Development Company";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iqura is having decades of experience in real estate software solutions and make a great addition to your IT teams and systems with our wide ranging technologies and industry specific experience."
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Contract and Claims management, Inventory management, Vendor management,Renewals management, Invoicing systems,Document publishing and Report automation, Provider matching, Scheduling, Routing and Dispatch,Authorizations and Cost management, Order processing and Management, Customer ordering, Storefronts and Customer management, Mortgages, Loans and Brokerage management systems, Title and transaction management systems,Realtors and Service Provider systems,MLS Integrations, Property listings and Marketplaces systems, Home Inspection software, Natural Hazards Disclosure software, Home Warranty software,Location &  Address Integrations, Real Estate Property &  Database Integrations,Document  automation, Accounting & Payment  Systems Integrations,Messaging &  Communications Integrations and Identity &  Access Management Integrations"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/real-estate-software-company";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const svgStyle = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23EEF5FF' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "350px",
  };

  const navigate = useNavigate();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
        What we do
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
        Services
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "techstack" })}>
        Techstack
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
        Who we are
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "career" })}>
        Careers
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "contact" })}>
        Contact
      </NavLink>
    </NavLinks>,
  ];
  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  let data = [
    {
      imageSrc: <Location style={imgStyle} />,
    },
    {
      imageSrc: <Database style={imgStyle} />,
    },
    {
      imageSrc: <Code style={imgStyle} />,
    },
    {
      imageSrc: <Dollar style={imgStyle} />,
    },
    {
      imageSrc: <Message style={imgStyle} />,
    },
    {
      imageSrc: <Key style={imgStyle} />,
    },
  ];

  const integrationSpecialities =
    logoTextData.thirdpartyintegrations.integrationspecialities.map(
      (item, index) => (
        <IconCard
          readmore={true}
          key={index}
          title={item.title}
          url={item.url}
          description={item.description}
          imageSrc={data[index].imageSrc}
        />
      )
    );

  function handleNavbarScroll(id, value) {
    // setCurrentNav(id);
    let idList = [
      "ourexpertise",
      "ourservices",
      "thirdparty",
      "techstack",
      "keybenefits",
    ];

    for (let i = 0; i < idList.length; i++) {
      if (id != idList[i]) {
        document.getElementById(idList[i]).style.paddingTop = "0px";
      }
    }

    document.getElementById(id).style.paddingTop = value;
    var eleme = document.getElementById(id);
    eleme.scrollIntoView({
      behavior: "smooth",
    });
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        let idList = [
          "ourexpertise",
          "ourservices",
          "thirdparty",
          "techstack",
          "keybenefits",
        ];

        for (let i = 0; i < idList.length; i++) {
          document.getElementById(idList[i]).style.paddingTop = "0px";
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLink = [
    {
      section: "head",
      label: "Our Expertise",
      scrollTo: "ourexpertise",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
    {
      section: "expertise",
      label: "Our Services",
      scrollTo: "ourservices",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
    {
      section: "services",
      label: "Third Party Integrations",
      scrollTo: "thirdparty",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
    {
      section: "thirdpartyintegration",
      label: "Techstack",
      scrollTo: "techstack",
      width: `${window.innerWidth <= 425 ? 110 : 40}px`,
    },
    {
      section: "techs_tack",
      label: "Key Benefits",
      scrollTo: "keybenefits",
      width: `${window.innerWidth <= 425 ? 210 : 130}px`,
    },
  ];

  const navLinksRendered = navLink.map((link) => (
    <Navtabslink
      key={link.section}
      className={activeSection === link.scrollTo ? "active" : ""}
      onClick={() => handleNavbarScroll(link.scrollTo, link.width)}
    >
      {link.label}
    </Navtabslink>
  ));

  return (
    <>
      <Navbar className="shadow-md" />
      <ContainerNav>
        <OpacityOverlay />
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </ContainerNav>
      <BreadCrumbs
        ref={childRef}
        title={"Real estate software company"}
        title1={"What we do"}
      />
      <ContactUsButton />
      <div className="overflow-hidden relative">
        <div
          className="flex transition-transform ease-out duration-300"
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((s) => {
            return (
              <div className="z-22" style={{ width: "100%" }}>
                {s}
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
          {slides.map((s, i) => {
            return (
              <div
                onClick={() => {
                  setCurrent(i);
                }}
              ></div>
            );
          })}
        </div>
      </div>
      <style>{styles}</style>
      <Container onClick={handleBreadCrumbClose}>
        <section id="head">
          <TwoCol>
            <WrapperDescription>
              <Description
                style={{
                  backgroundColor: "white",
                  marginTop: `${window.innerWidth <= 425 ? -140 : -220}px`,
                  padding: "40px",
                }}
              >
                <ImageHeader
                  imageHeaderData={imageHeader.realEstate}
                  imgsource={Realestate}
                />
              </Description>
            </WrapperDescription>
          </TwoCol>
        </section>
        <div>
          <Navtabs
            style={{
              top: "78px",
              zIndex: "2",
            }}
          >
            <div className="flex 	 justify-center lg:gap-12 gap-4 p-2  mx-2 mt-8 flex-wrap ">
              <div
                style={{ backgroundColor: "#eef5ff" }}
                className="flex shadow-md justify-center lg:gap-12 gap-4 p-2  px-10 flex-wrap "
              >
                {navLinksRendered}
              </div>
            </div>
          </Navtabs>
          <Wrapper>
            <div id="ourexpertise" className="div-class"></div>
            <SubHeadings heading1="Our" heading2="Expertise" />
            <ThreeColumnContainer>{ourExpertise}</ThreeColumnContainer>

            <div id="ourservices" className="div-class"></div>
            <SubHeadings heading1="Our" heading2="Services" />
            <Description>
              Our services include software development across the enterprise
              workflow chain including:
            </Description>
            <ThreeColumnContainer>{ourServices}</ThreeColumnContainer>
            <div id="thirdparty" className="div-class"></div>
            <SubHeadings heading1="Third Party" heading2="Integrations" />

            <Wrapper>
              <ThreeColumnContainer>
                <Description>
                  Our capabilities and experience with third-party systems and
                  APIs will help you maximize your workflows with efficient and
                  seamless integrations with your existing systems.
                </Description>
              </ThreeColumnContainer>

              <ThreeColumnContainer>
                {integrationSpecialities}
              </ThreeColumnContainer>
            </Wrapper>
            <div id="techstack" className="div-class"></div>

            <SubHeadings heading1="Our" heading2="Techstack" />
            <TechStack1 />
            <div id="keybenefits" className="div-class"></div>
            <SubHeadings heading1="Key" heading2="benefits" />

            <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>
          </Wrapper>
          <div id="footer"></div>
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default RealEstate;
